import React from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { RoleAndPermissionIcon } from 'components/common/icons';
import { PERMISSION_GROUP_KEY_MAPPING } from 'constants/mappings';
import { Col, EditableInfoComponent, Row, Typography } from 'components';
import { usePermissions } from 'feature/roleTabs/permissions/usePermissions';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { HasAccess } from 'components/common/accessControl';

const { Text } = Typography;

export const Permissions = React.memo(() => {
  const { data = {}, onUpdateClick } = usePermissions();
  const { hasAccess } = useAccessControl();

  return (
    <Row>
      <HasAccess role={PERMISSIONS.roles.role.read}>
        <Col span={14}>
          <EditableInfoComponent
            title={'Permissions'}
            onEdite={onUpdateClick}
            icon={<RoleAndPermissionIcon />}
            editable={hasAccess(PERMISSIONS.roles.role.write)}
          />
          <Row gutter={[0, 12]}>
            {Object.entries(data.permissions || {}).map(([category, permissions]) => (
              <Col key={category} span={24}>
                <Text
                  strong
                  className="font-size-16"
                  style={{ display: 'block', marginBottom: '4px', padding: '4px 0' }}
                  type={'secondary'}
                >
                  {PERMISSION_GROUP_KEY_MAPPING[category]}
                </Text>

                {(permissions as string[]).map((permission) => (
                  <Text
                    key={permission}
                    type="secondary"
                    className="font-size-16"
                    style={{
                      display: 'block',
                      padding: '2px 0',
                      borderBottom: '0.5px solid #E1E4EA',
                    }}
                  >
                    {permission}
                  </Text>
                ))}
              </Col>
            ))}
          </Row>
        </Col>
      </HasAccess>
    </Row>
  );
});
